import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { InputField } from '../../../../shared/components/input-field/input-field';
import { OriginVhostPHP } from '../../models/origin-vhost.models';

@Component({
  selector: 'app-edit-aliases-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
  ],
  templateUrl: './edit-aliases-dialog.component.html',
  styleUrl: './edit-aliases-dialog.component.scss',
})
export class EditAliasesDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<EditAliasesDialogComponent>);

  readonly data = inject<DialogData & { aliases: string[]; php: OriginVhostPHP }>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  form = this.fb.nonNullable.group({
    aliases: [[] as string[]],
    php: this.fb.group({
      version: [0],
    }),
  });

  ngOnInit(): void {
    this.form.controls.aliases.setValue(this.data.aliases);
    this.form.controls.php.controls.version.setValue(this.data.php.version);
  }

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
